import { Link } from 'react-router-dom';
import { HeaderProps } from '../types';
import { SITE_NAME, ARIA_LABELS } from '../../utils/constants';
import { FeralIcon } from '../common/FeralIcon';

export const Header: React.FC<HeaderProps> = ({ siteName = SITE_NAME }) => {
  return (
    <header className="sticky top-0 z-50 bg-deepBlack/95 backdrop-blur-sm border-b border-borderGray" role="banner">
      <div className="max-w-7xl mx-auto px-8 py-3 md:px-12 lg:px-20">
        <nav aria-label={ARIA_LABELS.MAIN_NAV} className="flex items-center justify-between">
          <Link 
            to="/" 
            className="flex items-center gap-3 hover:opacity-80 transition-opacity focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-deepBlack rounded"
            aria-label={ARIA_LABELS.LOGO}
          >
            <FeralIcon className="h-8 w-8 text-white" strokeWidth={6} />
            <span className="text-lg font-medium tracking-wider text-white font-mono pt-1">
              {siteName}
            </span>
          </Link>

          <div className="flex items-center space-x-6">
            <Link
              to="/privacy"
              className="text-sm font-mono text-gray-400 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-deepBlack rounded px-2 py-1 flex items-center h-full pt-1"
            >
              PRIVACY
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
};
